import { defineMessages } from "react-intl";

/**
 * LabelId → defineMessages catalog for price-summary bindings.
 */
export const labelMessages = defineMessages({
  AttendeeRange: {
    defaultMessage: "Hourly price for {min}–{max} guests",
  },
  AttendeeRangeReadout: {
    defaultMessage: "For {min}–{max} guests",
  },
  HourlyPrice: {
    defaultMessage: "Hourly price",
  },
  DiySpaceRental: {
    defaultMessage:
      "Space rental for {hours} {hours, plural, one {hour} other {hours}}",
  },
  DiySpaceRentalRate: {
    defaultMessage:
      "{price} x {hours} {hours, plural, one {hour} other {hours}}",
  },
  FsvSpaceRental: {
    defaultMessage:
      "{roomType} for {hours} {hours, plural, one {hour} other {hours}}",
  },
  RoomTypeHours: {
    defaultMessage:
      "{roomType} for {hours} {hours, plural, one {hour} other {hours}}",
  },
  Included: {
    defaultMessage: "Included",
  },
  HourlyDiscount: {
    defaultMessage: "Hourly discount",
  },
  DayRateDiscount: {
    defaultMessage: "Day rate discount ({percent}%)",
  },
  Entitlement: {
    defaultMessage: "Promotion",
  },
  FoodDrinkMinimum: {
    defaultMessage: "Food and drink minimum",
  },
  FoodMinimum: {
    defaultMessage: "Food minimum",
  },
  DrinkMinimum: {
    defaultMessage: "Drink minimum",
  },
  AddOnDetails: {
    defaultMessage: "Add-on details",
  },
  AddOnsTotal: {
    defaultMessage: "Add-ons total",
  },
  AddOnUnitPrice: {
    defaultMessage: "{price} {unit}",
  },
  AddOnUnitPriceOnly: {
    defaultMessage: "{price}",
  },
  AddOnUnitPerHour: {
    defaultMessage: "per hour",
  },
  AddOnUnitPerItem: {
    defaultMessage: "per item",
  },
  AddOnUnitPerPerson: {
    defaultMessage: "per person",
  },
  AdditionalPaymentsTotal: {
    defaultMessage: "Additional payments subtotal",
  },
  CleaningFee: {
    defaultMessage: "Cleaning fee",
  },
  SplitPaymentFee: {
    defaultMessage: "Part now, part later fee",
  },
  ProcessingFee: {
    defaultMessage: "Processing fee",
  },
  Taxes: {
    defaultMessage: "Taxes",
  },
  Credits: {
    defaultMessage: "Credits",
  },
  TerminalBooking: {
    defaultMessage: "Booking {state}",
  },
  Total: {
    defaultMessage: "Total",
  },
  GuestTotal: {
    defaultMessage: "Guest total",
  },
  TotalBeforeTaxes: {
    defaultMessage: "Total before taxes",
  },
  NewTotal: {
    defaultMessage: "New Total",
  },
  CalculatedAtCheckout: {
    defaultMessage: "Calculated at checkout",
  },
  SpaceRental: {
    defaultMessage: "Space rental",
  },
  PaymentAmount: {
    defaultMessage: "Payment amount",
  },
  StaffGratuityPercent: {
    defaultMessage: "{percent} Staff gratuity",
  },
  VatTaxes: {
    defaultMessage: "VAT taxes",
  },
  PrepaidByGuest: {
    defaultMessage: "Prepaid by guest",
  },
  FoodDrinkMinimumBeforeGratuity: {
    defaultMessage: "Before taxes and gratuity",
  },
  FoodDrinkMinimumBeforeGratuityGb: {
    defaultMessage: "Before taxes and applicable gratuity",
  },
  CollectedAddOnsTotal: {
    defaultMessage: "Add-ons total",
  },
  OutsideBaseGuestMessage: {
    defaultMessage:
      "Reservations over {duration} hours require custom pricing and venue approval.",
  },
  OutsideBaseHostMessage: {
    defaultMessage:
      "This inquiry exceeds your {basePricingLink}. Send an offer to see estimated earnings.",
  },
  SeeBasePricingLink: {
    defaultMessage: "See base pricing for {duration} hrs",
  },
  HostBasePricingLink: {
    defaultMessage: "{duration} hour base pricing",
  },
  EarningsSubtotal: {
    defaultMessage: "Earnings subtotal",
  },
  PeerspaceReservationFee: {
    defaultMessage: "Peerspace reservation fee",
  },
  ServiceFee: {
    defaultMessage: "Service fee",
  },
  EstimatedEarnings: {
    defaultMessage: "Estimated earnings",
  },
  Earnings: {
    defaultMessage: "Earnings",
  },
  PayoutFromPeerspace: {
    defaultMessage: "Payout from Peerspace",
  },
  DueToday: {
    defaultMessage: "Due today",
  },
  PaidToDate: {
    defaultMessage: "Already paid",
  },
  AlreadyPaid: {
    defaultMessage: "Already paid",
  },
  DifferenceDueToday: {
    defaultMessage: "Difference due today",
  },
  Refund: {
    defaultMessage: "Refund",
  },
  UpcomingCharge: {
    defaultMessage: "Upcoming charge",
  },
  UpcomingChargeDate: {
    defaultMessage: "{date}",
  },
  EventDate: {
    defaultMessage: "{date}",
  },
  DueAtVenue: {
    defaultMessage: "Due at venue",
  },
  GuestSpendAtVenue: {
    defaultMessage: "Guest spend at venue",
  },
  BeforeGratuity: {
    defaultMessage: "before gratuity",
  },
  IncludesDueAtVenue: {
    defaultMessage: "Includes {amount} due at venue",
  },
  PrivateDiningRoom: {
    defaultMessage: "Private dining room",
  },
});
